<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    name: 'app',
    data() {
      return {}
    },
    created() {
    },
  }
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/App.vue